export default __webpack_public_path__ + "static/media/Product Image.c53bc02b.jpg";